import sliceCreator from '../../index.jsx';
import {SUPER_ADMIN_LOGIN} from '../../../constants/index.jsx';
const _superAdminLoginAction = sliceCreator('SUPER_ADMIN_LOGIN', SUPER_ADMIN_LOGIN, 'post');

const { asyncAction: superAdminLoginAction, reducer, clearData: clearSuperAdminLoginAction } = _superAdminLoginAction;

export default reducer;

export {
    superAdminLoginAction,
    clearSuperAdminLoginAction
}